import classNames from 'classnames';
import { forwardRef } from 'react';
const subtitleCss = "s4lzcc0";
const Subtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subtitleCss, props.className)} />;
});
export default Subtitle;

require("./subtitle.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./subtitle.js");